import { LEAGUES } from '@/constants/leagues';
import { replaceDiacritis } from '@/helpers/players-helper';

export const EQUIPOS_LALIGA = {
    REAL_MADRID: 541,
    BARCELONA: 529,
    ATLETICO_MADRID: 530,
    REAL_SOCIEDAD: 548,
    VILLARREAL: 533,
    VALENCIA: 532,
    SEVILLA: 536,
    GETAFE: 546,
    ATHLETIC_CLUB: 531,
    CELTA_VIGO: 538,
    CA_OSASUNA: 727,
    BETIS: 543,
    ALAVES: 542,
    VALLADOLID: 720,
    LEGANES: 537,
    GIRONA: 547,
    ESPANYOL: 540,
    MALLORCA: 798,
    RAYO_VALLECANO: 728,
    LAS_PALMAS: 534,
    LEVANTE: 539,
    ELCHE_CF: 797,
    REAL_OVIEDO: 718,
};

const equipos = [
    {
        fid: 4,
        id: EQUIPOS_LALIGA.BARCELONA,
        short: 'Barça',
        name: 'Barcelona',
        slug: 'fc-barcelona',
        image: 'fc-barcelona.png',
        rank: 1,
        powerRanking: '0adec11b-cb2a-4c21-afea-80f97509be28',
        betName: 'Barcelona',
    },
    {
        fid: 15,
        id: EQUIPOS_LALIGA.REAL_MADRID,
        short: 'R.Madrid',
        name: 'Real Madrid',
        slug: 'real-madrid',
        image: 'real-madrid.png',
        rank: 2,
        powerRanking: '9f054f65-d7cc-4295-a311-7aeb6fee484f',
        betName: 'Real Madrid',
    },
    {
        fid: 2,
        id: EQUIPOS_LALIGA.ATLETICO_MADRID,
        short: 'Atleti',
        name: 'Atlético de Madrid',
        slug: 'atletico-de-madrid',
        image: 'atletico-de-madrid.png',
        rank: 3,
        powerRanking: 'f7e6ded6-a76c-4b9e-b9d3-04a6c2fbeb6d',
        betName: 'Atletico Madrid',
    },
    {
        fid: 3,
        id: EQUIPOS_LALIGA.ATHLETIC_CLUB,
        short: 'Athletic',
        name: 'Athletic Club',
        slug: 'athletic-club',
        image: 'athletic-club.png',
        rank: 4,
        powerRanking: '903b269f-48f8-4e2c-ba77-89091e01ec9e',
        betName: 'Athletic Bilbao',
    },
    {
        fid: 20,
        id: EQUIPOS_LALIGA.VILLARREAL,
        short: 'Villarreal',
        name: 'Villarreal',
        slug: 'villarreal-cf',
        image: 'villarreal-cf.png',
        rank: 5,
        powerRanking: '69195192-80b3-4d90-8482-6e819ac2a9a2',
        betName: 'Villarreal',
    },
    {
        fid: 5,
        id: EQUIPOS_LALIGA.BETIS,
        short: 'Betis',
        name: 'Real Betis',
        slug: 'real-betis',
        image: 'real-betis.png',
        rank: 6,
        powerRanking: '3b717125-c584-4423-9fc3-e37496a6b309',
        betName: 'Real Betis',
    },
    {
        fid: 6,
        id: EQUIPOS_LALIGA.CELTA_VIGO,
        short: 'Celta',
        name: 'Celta de Vigo',
        slug: 'rc-celta',
        image: 'rc-celta.png',
        rank: 7,
        powerRanking: 'f6a4c3c4-6f4e-444e-abf4-02b1fc268a58',
        betName: 'Celta Vigo',
    },
    {
        fid: 14,
        id: EQUIPOS_LALIGA.RAYO_VALLECANO,
        short: 'Rayo',
        name: 'Rayo Vallecano',
        slug: 'rayo-vallecano',
        image: 'rayo-vallecano.png',
        rank: 8,
        powerRanking: 'b5c9630b-4f93-40d0-8fa9-df3f5ad2f77c',
        betName: 'Rayo Vallecano',
    },
    {
        fid: 13,
        id: EQUIPOS_LALIGA.CA_OSASUNA,
        short: 'Osasuna',
        name: 'Osasuna',
        slug: 'c-a-osasuna',
        image: 'c-a-osasuna.png',
        rank: 9,
        powerRanking: 'bfc8d9ab-26ae-42ca-b45c-13fee9c96c53',
        betName: 'Osasuna',
    },
    {
        fid: 33,
        id: EQUIPOS_LALIGA.MALLORCA,
        short: 'Mallorca',
        name: 'Mallorca',
        slug: 'rcd-mallorca',
        image: 'rcd-mallorca.png',
        rank: 10,
        powerRanking: 'c1a74e22-fefc-4b84-8cbe-103a68eeb182',
        betName: 'Mallorca',
    },
    {
        fid: 16,
        id: EQUIPOS_LALIGA.REAL_SOCIEDAD,
        short: 'R.Sociedad',
        name: 'Real Sociedad',
        slug: 'real-sociedad',
        image: 'real-sociedad.png',
        rank: 11,
        powerRanking: '78975b30-66d7-4af7-ba9e-0c52638a0adf',
        betName: 'Real Sociedad',
    },
    {
        fid: 18,
        id: EQUIPOS_LALIGA.VALENCIA,
        short: 'Valencia',
        name: 'Valencia',
        slug: 'valencia-cf',
        image: 'valencia-cf.png',
        rank: 12,
        powerRanking: '2be00225-a990-4cb3-8f60-c3a1646cda98',
        betName: 'Valencia',
    },
    {
        fid: 9,
        id: EQUIPOS_LALIGA.GETAFE,
        short: 'Getafe',
        name: 'Getafe',
        slug: 'getafe-cf',
        image: 'getafe-cf.png',
        rank: 13,
        powerRanking: '34cdf574-e547-4c89-a82a-be92eb686ce0',
        betName: 'Getafe',
    },
    {
        fid: 8,
        id: EQUIPOS_LALIGA.ESPANYOL,
        short: 'Espanyol',
        slug: 'rcd-espanyol',
        name: 'Espanyol',
        image: 'espanyol.png',
        rank: 14,
        powerRanking: '14b8e9db-be65-443b-a618-ef857053b506',
        betName: 'Espanyol',
    },
    {
        fid: 21,
        id: EQUIPOS_LALIGA.ALAVES,
        short: 'Alavés',
        name: 'Alavés',
        slug: 'd-alaves',
        image: 'd-alaves.png',
        rank: 15,
        powerRanking: '0b2b6d38-4c24-4777-92a4-3dc735378876',
        betName: 'CD Alaves',
    },
    {
        fid: 28,
        id: EQUIPOS_LALIGA.GIRONA,
        short: 'Girona',
        name: 'Girona',
        slug: 'girona-fc',
        image: 'girona-fc.png',
        rank: 16,
        powerRanking: 'dca0081c-5bbd-42c1-8f0a-5312a51b31f9',
        betName: 'Girona',
    },
    {
        fid: 17,
        id: EQUIPOS_LALIGA.SEVILLA,
        short: 'Sevilla',
        name: 'Sevilla',
        slug: 'sevilla-fc',
        image: 'sevilla-fc.png',
        rank: 17,
        powerRanking: 'ce32734c-a08d-4f3b-a0c4-ac9e342bd0c8',
        betName: 'Sevilla',
    },
    {
        fid: 20,
        id: EQUIPOS_LALIGA.LEVANTE,
        short: 'Levante',
        name: 'Levante',
        slug: 'levante-cf',
        image: 'levante-cf.png',
        rank: 18,
        powerRanking: '39858fe5-6919-4b6f-917f-9b29744e7850',
        betName: 'Levante',
    },
    {
        fid: 20,
        id: EQUIPOS_LALIGA.ELCHE_CF,
        short: 'Elche',
        name: 'Elche CF',
        slug: 'elche-cf',
        image: 'elche-cf.png',
        rank: 19,
        powerRanking: 'fc960a2d-b9b9-4b45-bce5-e67f4ec1cc9f',
        betName: 'Elche',
    },
    {
        fid: 20,
        id: EQUIPOS_LALIGA.REAL_OVIEDO,
        short: 'R. Oviedo',
        name: 'Real Oviedo',
        slug: 'real-oviedo',
        image: 'real-oviedo.png',
        rank: 20,
        powerRanking: 'ef9aa007-4e15-42c4-b173-04b22d155292',
        betName: 'Real Oviedo',
    },
];

// Exportar el array equipos para uso en getStaticPaths
export { equipos };

export const obtenerTodosLosIds = () => {
    return equipos.map((x) => x.id);
};

export const obtenerEquipoPorFantasyId = (fantasyId) => {
    return equipos.find((x) => x.fid == fantasyId);
};

export const obtenerLigas = () => {
    return [
        { id: LEAGUES.LA_LIGA, name: 'La Liga' },
        { id: LEAGUES.EUROCOPA, name: 'Eurocopa' },
    ];
};

export const obtenerEquiposPorCategoria = (isCountry) => {
    if (isCountry === true) {
        return equipos.filter((x) => x.isCountry);
    } else if (isCountry === false) {
        return equipos.filter((x) => !x.isCountry);
    }

    return equipos;
};

export const obtenerEquipos = (_, addAll = false) => {
    let equiposToReturn = [...equipos];

    if (addAll) {
        equiposToReturn.unshift({ id: 'all', name: 'Todos' });
    }

    return equiposToReturn;
};

export const isEquipoLaLiga = (teamId) => {
    if (teamId > 0) {
        return equipos.some((x) => x?.id == teamId);
    }

    return false;
};

export const obtenerEquipo = (teamId) => {
    if (teamId > 0) {
        return equipos.find((x) => x?.id == teamId);
    }

    return teamId;
};

export const obtenerNombreDeEquipo = (teamId) => {
    if (teamId > 0) {
        return equipos.find((x) => x?.id == teamId)?.short;
    }

    return teamId;
};

export const obtenerNombreLargoDelEquipo = (teamId) => {
    if (teamId > 0) {
        return equipos.find((x) => x?.id == teamId)?.name;
    }

    return '';
};

export const obtenerEquipoPorSlug = (slug) => {
    if (slug) {
        return equipos.find((x) => x?.slug == slug);
    }

    return null;
};

export const obtenerTeamIdBySlug = (slug) => {
    if (slug) {
        return equipos.find((x) => x?.slug == slug)?.id;
    }

    return null;
};

export const obtenerTeamValid = (slugOrId) => {
    if (!slugOrId) {
        return null;
    }

    // 1) Intentar por slug
    const teamBySlug = equipos.find((x) => x?.slug == slugOrId);
    if (teamBySlug?.id > 0) {
        return teamBySlug;
    }

    // 2) Intentar por id
    const asNumber = Number(slugOrId);
    if (Number.isFinite(asNumber) && asNumber > 0) {
        const teamById = equipos.find((x) => x?.id == asNumber);
        if (teamById) {
            return teamById;
        }
    }

    // 3) Ninguno válido
    return null;
};

export const obtenerEquipoPorIdOrSlug = (teamId, slug) => {
    if (teamId > 0) {
        return equipos.find((x) => x?.id == teamId);
    } else {
        return equipos.find((x) => x?.slug == slug);
    }
};

export const getRightTeamSlug = (slug) => {
    if (slug === 'valladolid') {
        return 'r-valladolid-cf';
    }

    return slug;
};

export const toTeamSlug = (name) => {
    if (name) {
        const nameWithoutSpaces = name.replace(/ /g, '-').toLowerCase();
        return `-${replaceDiacritis(nameWithoutSpaces)}`;
    }

    return '';
};

export const isCountryTeamLeague = (leagueId) => {
    switch (leagueId) {
        case LEAGUES.EUROCOPA:
        case LEAGUES.COPA_AMERICA:
        case LEAGUES.FIFA_WORLD_CLUB:
        case LEAGUES.NATIONS_LEAGUE:
        case LEAGUES.FIFA_FRIENDLIES:
        case LEAGUES.EURO_CLASIFICACION:
            return true;
        default:
            return false;
    }
};

/**
 * Busca un equipo por su nombre en las casas de apuestas
 * @param {string} betName - Nombre del equipo en la casa de apuestas
 * @returns {object|null} - Equipo encontrado o null
 */
export const buscarEquipoPorBetName = (betName) => {
    if (!betName) return null;

    // Normalizar el nombre para búsqueda (remover acentos, lowercase, etc.)
    const normalizar = (str) => {
        return str
            .toLowerCase()
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '') // Remover acentos
            .trim();
    };

    const betNameNormalizado = normalizar(betName);

    // Buscar en todos los equipos (usa la variable 'equipos' interna)
    const todosEquipos = equipos;

    // 1. Buscar coincidencia exacta por betName
    const exactMatch = todosEquipos.find(
        (equipo) => equipo.betName && normalizar(equipo.betName) === betNameNormalizado
    );

    if (exactMatch) return exactMatch;

    // 2. Buscar coincidencia por nombre normal
    const nameMatch = todosEquipos.find((equipo) => normalizar(equipo.name) === betNameNormalizado);

    if (nameMatch) return nameMatch;

    // 3. Buscar coincidencia parcial (contiene)
    const partialMatch = todosEquipos.find((equipo) => {
        const equipoBetName = normalizar(equipo.betName || equipo.name);
        return equipoBetName.includes(betNameNormalizado) || betNameNormalizado.includes(equipoBetName);
    });

    return partialMatch || null;
};

/**
 * Parsea el nombre del evento (ej: "Athletic Bilbao v Real Madrid") y retorna los equipos
 * @param {string} eventName - Nombre del evento (formato: "Equipo Local v Equipo Visitante")
 * @returns {{home: object|null, away: object|null}}
 */
export const parseEventTeams = (eventName) => {
    if (!eventName) return { home: null, away: null };

    const separators = [' v ', ' vs ', ' - '];
    let homeTeamName = null;
    let awayTeamName = null;

    for (const separator of separators) {
        if (eventName.includes(separator)) {
            [homeTeamName, awayTeamName] = eventName.split(separator);
            break;
        }
    }

    if (!homeTeamName || !awayTeamName) {
        return { home: null, away: null };
    }

    return {
        home: buscarEquipoPorBetName(homeTeamName.trim()),
        away: buscarEquipoPorBetName(awayTeamName.trim()),
    };
};

export const getTranslatedTeamName = (teamId, teamName) => {
    const team = obtenerEquipo(teamId);

    if (team) {
        return team.name;
    }

    return teamName;
};

export const obtenerSlugDeEquipos = () => {
    return equipos.map((x) => x.slug);
};

/**
 * Genera los paths para getStaticPaths de Next.js para todas las rutas de equipos
 * @returns {Array} Array de objetos con formato { params: { slug: string } }
 */
export const obtenerStaticPathsEquipos = () => {
    return equipos.map((equipo) => ({
        params: { slug: equipo.slug },
    }));
};
